/* =========================================================
   KINMITSU — minimal, dependency-free interactions
   ========================================================= */

(() => {
  // Note: Shopify provides its own header (.header), so we skip prototype's #siteHeader logic.
  const header = document.getElementById("siteHeader");
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 8) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ----- Scroll-triggered fade-in -----
  const supportsIO = "IntersectionObserver" in window;
  if (!supportsIO) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -6% 0px" }
  );

  const fadeSelectors = [
    ".section-num",
    ".section-title",
    ".story-headline",
    ".story-body",
    ".story-image",
    ".products-head",
    ".km-product",
    ".about-item",
    ".about-credo",
    ".about-video",
    ".about-philosophy",
    ".interlude-quote",
    ".director-inner",
    ".contact-title",
    ".contact-sub",
    ".newsletter",
    ".contact-fine",
    ".footer-brand",
    ".footer-col",
  ];

  fadeSelectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      el.classList.add("fade-up");
      observer.observe(el);
    });
  });

  // also add the in-view class to the .story section itself
  // for the underline animation under "共に"
  const storySection = document.querySelector(".story");
  if (storySection) {
    const storyObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            storyObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    storyObserver.observe(storySection);
  }

  // ----- Stagger: products & about cards -----
  document.querySelectorAll(".km-product").forEach((el, i) => {
    el.style.transitionDelay = `${0.05 + i * 0.13}s`;
  });
  document.querySelectorAll(".about-item").forEach((el, i) => {
    el.style.transitionDelay = `${0.05 + i * 0.13}s`;
  });
  document.querySelectorAll(".footer-col").forEach((el, i) => {
    el.style.transitionDelay = `${i * 0.08}s`;
  });

  // ----- Newsletter form -----
  // Shopify の {% form 'customer' %} ネイティブ送信に任せる（preventDefault しない）。
  // 送信成功/エラーは Liquid 側で form.posted_successfully? / form.errors を表示。

  // ----- Subtle parallax on hero image (desktop only) -----
  const heroImg = document.querySelector(".hero-image img");
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  if (heroImg && isDesktop && !reducedMotion) {
    let ticking = false;
    const update = () => {
      const y = window.scrollY;
      // parallax limited to first viewport
      if (y < window.innerHeight) {
        const offset = y * 0.18;
        heroImg.style.transform = `translateY(${offset}px) scale(1)`;
      }
      ticking = false;
    };
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }
})();
